import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from 'cre-ng';
import dayjs from 'dayjs';
import { Carousel } from 'primeng/carousel';

import { AuthService } from '@app/core/auth.service';
import { BonusInformation } from '@app/core/model/configuration.model';
import {
  BonusStatByMonth,
  BonusStats,
  BonusStatusByMonth,
  DisplayableType,
  Month,
  OptInStatus,
} from '@app/core/model/qualifications.model';
import { IBonusQualificationService } from '@app/core/services/interface/IBonusQualificationService';
import { IConfigurationService } from '@app/core/services/interface/IConfigurationService';
import { IPaymentService } from '@app/core/services/interface/IPaymentService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { OptInInfo } from './wig-bonus.model';

@Component({
  selector: 'app-wig-bonus',
  templateUrl: './wig-bonus.component.html',
  styleUrls: ['./wig-bonus.component.css'],
})
export class WigBonusComponent implements OnInit {
  @ViewChild('monthlyStatsCarousel') monthlyStatsCarousel: Carousel;
  @Input() optInStatus: OptInStatus;
  bonusInformation: BonusInformation[];
  bonusPayableMonths: BonusStatusByMonth[];
  bonusQualificationService: IBonusQualificationService;
  bonusStats: { [key: string]: BonusStatByMonth };
  configurationService: IConfigurationService;
  currentMonth: Month;
  currentMonthIndex: number;
  currentPeriod: string;
  defaultMonthIndex: number;
  displayableStats: BonusStats;
  evaluationMonth: string;
  isLoading: boolean;
  isSidebarVisible: boolean;
  isSplitByTeam: boolean;
  isViewed: boolean;
  lastMonthIndex: number;
  legalPayType: string;
  monthList: Month[];
  optInInfo: OptInInfo;
  payDecrease: number;
  payIncrease: number;
  payIncrement: number;
  paymentMonth: string;
  paymentService: IPaymentService;
  paymentUnit: string;
  payType: string;
  salaryPayTypes: string[];
  thisMonth: string;

  constructor(
    private authService: AuthService,
    private datePipe: DatePipe,
    serviceFactory: ServiceFactory,
    private notificationService: NotificationService
  ) {
    this.isLoading = true;
    this.salaryPayTypes = ['SALARY', 'HOUROT', 'HOURLY', 'SALCNS', 'ITMS1'];
    this.bonusQualificationService = serviceFactory.getBonusQualificationService();
    this.paymentService = serviceFactory.getPaymentService();
    this.configurationService = serviceFactory.getConfigurationService();
    this.optInInfo = {
      startDate: '',
      firstMonth: '',
      secondMonth: '',
    };
    this.bonusPayableMonths = [];
    this.monthList = [];
    this.bonusStats = {};
    this.currentMonthIndex = 0;
  }
  displayOptInSideBar(): void {
    this.isSidebarVisible = true;
  }

  hideSidebar(): void {
    this.isSidebarVisible = false;
  }

  loadDisplayableStats(): void {
    const qualifyPeriod = new Date();
    qualifyPeriod.setDate(1);
    const paramQualifyPeriod = this.datePipe.transform(qualifyPeriod, 'yyyy-MM-dd');
    this.currentPeriod = paramQualifyPeriod;
    this.bonusQualificationService
      .getDisplayableStats(this.authService.getCurrentUser().username, paramQualifyPeriod)
      .then((response) => {
        this.displayableStats = response;
      });
  }

  loadDynamicText(): void {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    // const paramStartDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
    const endDate = new Date();
    // const paramEndDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');

    this.paymentService
      .getDriverPayType(this.authService.getCurrentUser().username)
      .then((response) => {
        if (response && response.payType === 'TSM') {
          this.payType = ' CPM';
          this.payIncrement = 1;
          this.payDecrease = 2;
          this.payIncrease = 3;
          this.isSplitByTeam = true;
          this.paymentUnit = 'CPM';
        } else if (response && response.payType !== 'TSM') {
          this.payType = '%';
          this.payIncrement = 2;
          this.payDecrease = 4;
          this.payIncrease = 6;
          this.isSplitByTeam = false;
          this.paymentUnit = '%';
        }
      });

    const tempDate = new Date();
    this.thisMonth = this.datePipe.transform(tempDate, 'LLLL');
    tempDate.setMonth(tempDate.getMonth() + 1);
    this.evaluationMonth = this.datePipe.transform(tempDate, 'LLLL');
    tempDate.setMonth(tempDate.getMonth() + 1);
    this.paymentMonth = this.datePipe.transform(tempDate, 'LLLL');
  }

  loadOptInStatus(): void {
    this.optInInfo.startDate = dayjs(this.optInStatus.startDate).format('MMMM DD');
    this.optInInfo.firstMonth = dayjs(this.optInStatus.startDate).add(1, 'M').format('MMMM');
    this.optInInfo.secondMonth = dayjs(this.optInStatus.startDate).add(2, 'M').format('MMMM');
    this.bonusQualificationService
      .getBonusStatus(this.authService.getCurrentUser().username, DisplayableType.None)
      .then((payableMonths) => {
        this.bonusPayableMonths = payableMonths || [];
        this.monthList = payableMonths.map((value: BonusStatusByMonth) => {
          const date = new Date(value.month);
          return {
            startDate: value.month,
            endDate: value.month,
            month: date.toLocaleString('default', { month: 'long' }),
            description: value.description,
          };
        });
        this.currentMonthIndex = this.monthList.findIndex((value) => {
          return value.month === new Date().toLocaleString('default', { month: 'long' });
        });
        this.currentMonth = this.monthList[this.currentMonthIndex];
        this.lastMonthIndex = this.monthList.length - 1;
        this.bonusQualificationService
          .getBonusStatusByMonth(
            this.authService.getCurrentUser().username,
            this.currentMonth.startDate
          )
          .then((bonusStatus) => {
            this.bonusStats[this.currentMonth.startDate + ''] = bonusStatus;
            this.monthlyStatsCarousel.navBackward(this, this.currentMonthIndex);
          });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  nextMonth(): void {
    if (this.currentMonthIndex < this.lastMonthIndex) {
      this.currentMonthIndex++;
      this.currentMonth = this.monthList[this.currentMonthIndex];
      if (!this.bonusStats[this.currentMonth.startDate + '']) {
        this.bonusQualificationService
          .getBonusStatusByMonth(
            this.authService.getCurrentUser().username,
            this.currentMonth.startDate
          )
          .then((bonusStatus) => {
            this.bonusStats[this.currentMonth.startDate + ''] = bonusStatus;
            this.monthlyStatsCarousel.navForward(this, this.currentMonthIndex);
          });
      } else {
        this.monthlyStatsCarousel.navForward(this, this.currentMonthIndex);
      }
    }
  }

  ngOnInit(): void {
    // this.isViewed = this.authService.isViewed(); TODO
    this.isLoading = true;
    this.isViewed = true;
    this.loadOptInStatus();
    this.loadDynamicText();
    this.loadDisplayableStats();
    this.loadBonusInformation();
  }

  optIn(): void {
    const startDate = new Date();
    const paramStartDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');

    this.bonusQualificationService
      .optInDriver(this.authService.getCurrentUser().username, paramStartDate)
      .then(() => {
        window.location.reload();
      })
      .catch((e: HttpErrorResponse) => {
        this.notificationService.showError('Error Responding', e.error);
      });
  }

  previousMonth(): void {
    if (this.currentMonthIndex > 0) {
      this.currentMonthIndex--;
      this.currentMonth = this.monthList[this.currentMonthIndex];
      if (!this.bonusStats[this.currentMonth.startDate + '']) {
        this.bonusQualificationService
          .getBonusStatusByMonth(
            this.authService.getCurrentUser().username,
            this.currentMonth.startDate
          )
          .then((bonusStatus) => {
            this.bonusStats[this.currentMonth.startDate + ''] = bonusStatus;
          });
      }
      this.monthlyStatsCarousel.navBackward(this, this.currentMonthIndex);
    }
  }

  private loadBonusInformation(): void {
    this.configurationService.getConfiguration().then((response) => {
      this.bonusInformation = response.bonusInformation;
      this.legalPayType = this.findBonusTextDescription('Legal_PayType');
    });
  }

  private findBonusTextDescription(name: string): string {
    return this.bonusInformation
      ? this.bonusInformation.find((x) => x.name === name).description
      : '';
  }
}
